import {connect} from '../../app/connect';
import Filter from './Filter';
import {setQueryParamsAction} from '../../app/actions';
import {
  getAllOxygenMappings,
  getQueryParams,
  getIsLocationsTreeLoading,
  getIsLocationsLoadingError,
  getLocationsTreeNodes,
  getCurrentViewType,
  getFieldIssueTypesV2IdToTitleMap,
  getActiveIssueSubTypesGroupedDropdownOptions,
  getActiveIssueRootCausesGroupedDropdownOptions,
  getSortedIssueAttributeDefinitionsWhichAreMappedToIssueTypes,
  getSubLocationCountsMap,
  getAllUsers,
  getGroupedProjectAllEntities,
  isFieldManagementActive
} from '../../app/selectors';
import LocationsThunk from '../../app/thunk/locationsThunk';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';
import {getFullStatusOptions} from '../../constants/status-types';
import {viewTypes} from '../../constants/view-types';

const mapStateToProps = state => ({
  oxygen: getAllOxygenMappings(state),
  queryParams: getQueryParams(state),
  fieldIssueTypes: getFieldIssueTypesV2IdToTitleMap(state),
  isLocationsTreeLoading: getIsLocationsTreeLoading(state),
  isLocationsLoadingError: getIsLocationsLoadingError(state),
  locationsTreeNodes: getLocationsTreeNodes(state),
  viewType: getCurrentViewType(state),
  groupedProjectEntities: getGroupedProjectAllEntities(state),
  statusOptions: getFullStatusOptions(state),
  projectUsers: getAllUsers(state),
  filterBySubTypeEnabled: featureFlags.get(FEATURE_FLAGS.FILTER_BY_SUB_TYPE),
  subTypesGroupedDropdownOptions: getActiveIssueSubTypesGroupedDropdownOptions(state),
  issueRootCausesGroupedDropdownOptions: getActiveIssueRootCausesGroupedDropdownOptions(state),
  isDateSelectorMigrationEnabled: featureFlags.get(FEATURE_FLAGS.DATE_SELECTOR),
  filterByCustomAttributesEnabled: featureFlags.get(FEATURE_FLAGS.FILTER_BY_CUSTOM_ATTRIBUTES),
  customAttributes: getSortedIssueAttributeDefinitionsWhichAreMappedToIssueTypes(state),
  subLocationCounts: getSubLocationCountsMap(state),
  showLinkedToFilter:
    featureFlags.get(FEATURE_FLAGS.CHECKLIST_INDICATOR) &&
    isFieldManagementActive(state) &&
    getCurrentViewType(state) === viewTypes.PROJECT
});

const mapDispatchToProps = {
  setQueryParamsAction,
  getDefaultLocationTree: LocationsThunk.getDefaultTree
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);
